import { getItemFromArray } from '@/pages/intelligence/utils/tableUtils';
// import { steamSalesDetailList } from '@/pages/intelligence/pages/TopCharts/PCGames/_config/constant';

export const PLAYER_COUNTRY_BAR_TOP_COUNT = 19;

export const isOthersMarketRow = (market: any): boolean => {
  if (typeof market !== 'string') return false;
  const lower = market.toLowerCase();
  return lower === 'others' || lower === 'other';
};

export const getPlayerCountryMetricValue = (
  item: any,
  metricKey: string,
): number => {
  if (!item || !metricKey) return 0;
  const metrics = Array.isArray(item?.metrics) ? item.metrics : [];
  const candidates = [metricKey];
  const shortKey = metricKey.includes('__')
    ? metricKey.split('__').pop() || ''
    : '';
  if (shortKey) {
    candidates.push(shortKey);
  }
  for (const key of candidates) {
    const found = metrics.find(
      (m: any) => m?.name === key || m?.metric === key,
    );
    if (found) {
      const val = Number(found?.value);
      return Number.isFinite(val) ? val : 0;
    }
  }
  return 0;
};

/** 柱状图固定展示 Top N 国家 + 1 个 Others（其余国家汇总） */
export const buildTopCountriesBarChartData = (
  list: any[],
  metricKey: string,
  topCountryCount = PLAYER_COUNTRY_BAR_TOP_COUNT,
): any[] => {
  if (!Array.isArray(list) || list.length === 0) return [];

  const othersRows = list.filter((item) => isOthersMarketRow(item?.market));
  const nonOthers = list.filter((item) => !isOthersMarketRow(item?.market));

  const sorted = [...nonOthers].sort(
    (a, b) =>
      getPlayerCountryMetricValue(b, metricKey) -
      getPlayerCountryMetricValue(a, metricKey),
  );

  const topCountries = sorted.slice(0, topCountryCount);
  const overflowCountries = sorted.slice(topCountryCount);

  if (overflowCountries.length === 0 && othersRows.length <= 1) {
    return [...topCountries, ...othersRows.slice(0, 1)];
  }

  const rowsToMerge = [...overflowCountries, ...othersRows];
  const mergedMetricsMap: Record<
    string,
    { name: string; value: number; dod: any }
  > = {};

  rowsToMerge.forEach((item) => {
    const metrics = Array.isArray(item?.metrics) ? item.metrics : [];
    metrics.forEach((m: any) => {
      const name = m?.name || m?.metric;
      if (!name) return;
      if (!mergedMetricsMap[name]) {
        mergedMetricsMap[name] = { name, value: 0, dod: null };
      }
      const val = Number(m?.value);
      if (Number.isFinite(val)) {
        mergedMetricsMap[name].value += val;
      }
    });
  });

  return [
    ...topCountries,
    {
      market: 'others',
      name: 'Others',
      name_cn: '其他',
      metrics: Object.values(mergedMetricsMap),
    },
  ];
};

export const getSteamSalesTableList = (segVal: string, list: any[] = []) => {
  const getTableHeaderItem = (keyVal: string) => {
    return getItemFromArray({
      list: list,
      key: 'value',
      keyVal: keyVal,
    });
  };

  const infoItem = getTableHeaderItem(segVal);
  const tHeadList = [infoItem];

  if (segVal === 'pcu' || segVal === 'acu') {
    const secondInfoItemKey =
      segVal === 'pcu' ? 'acu' : 'pcu';
    const secondInfoItem = getTableHeaderItem(secondInfoItemKey);
    tHeadList.push(secondInfoItem);
  } else if (segVal === 'est_revenue' || segVal === 'est_units') {
    const secondInfoItemKey =
      segVal === 'est_revenue' ? 'est_units' : 'est_revenue';
    const secondInfoItem = getTableHeaderItem(secondInfoItemKey);
    tHeadList.push(secondInfoItem);
  }

  return tHeadList;
};
